import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@components/bootstrap';
import Navbar from '@components/bootstrap/Navbar/Navbar';
import './AuthenticatedLayout.scss';
const AuthenticatedLayout = ({ children, title, subtitle, tabs, activeTab, onTabChange }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            console.log('🚪 AuthenticatedLayout: Starting logout...');
            await logout();
            console.log('✅ AuthenticatedLayout: Logout successful, redirecting...');
            navigate('/login');
        }
        catch (error) {
            console.error('❌ AuthenticatedLayout: Logout error:', error);
            // Even if logout fails, redirect to login
            navigate('/login');
        }
    };
    return (_jsxs("div", { className: "authenticated-layout", children: [_jsx(Navbar, { variant: "light", expand: "lg", isAuthenticated: true, user: user ? {
                    name: user.name,
                    email: user.email,
                    role: user.role
                } : undefined, onLogoutClick: handleLogout }), _jsxs("main", { className: "main-content container-fluid", children: [(title || subtitle || tabs) && (_jsx(PageHeader, { title: title, subtitle: subtitle, tabs: tabs, activeTab: activeTab, onTabChange: onTabChange })), _jsx("div", { className: "page-content", children: children })] })] }));
};
export default AuthenticatedLayout;
